import { Box, Stack, Typography } from "@mui/material"
import lcc_logo from '../../images/lcc_logo_full.png';

const OrderSubmittedView = ({link}) => {
    return <Box sx={{margin: 2}}>
    <Stack direction="column" spacing={2} alignContent={"center"} alignItems={"center"}>
      <Typography variant="h1">Thank You For Your Order</Typography>
      <Typography variant="p">Our team will be reviewing your purchase order momentarily</Typography>
      <Typography variant="h1">What's Next?</Typography>
      <Typography variant="h2">You'll soon receive an email with a link to remit payment</Typography>
      <Typography variant="p">Sit back and relax, Left Coast Cabinets will get working on your order right away<br /><br /><br /></Typography>
      <Typography variant="p"><i>If you’d like to view or change your purchase order, you can do so with this link:</i></Typography>
      <Typography variant="p"><a href={link}>{link}</a></Typography>
      <Typography variant="p"><i>(Note that no changes can be made when your order has entered production)</i></Typography>
      <Typography variant="p">Thank you for your business<br /></Typography>
      <img src={lcc_logo} alt="Left Coast Cabinets" style={{height: 256}} />
    </Stack>
  </Box>
}

export { OrderSubmittedView }